import AbsComponent from '../../common/AbsComponent';
// import Templ from './CharacterInfoTempl';

/**
 * StateBanner class
 * 신규&복귀배너
 * @category main
 */
class StateBanner extends AbsComponent {
	constructor(_store = {}, _el = '') {
		super(_store, _el);

		this.$banner = null;

		this.setting();
	}

	setting() {
		// 비로그인 또는 기존 본서버 고객일 경우
		if (!this.store.getData('config').isLogin) {
			this.$banner = $(`${this.el} .state-banner-1`);

			this.setBanner();
		// 로그인 시 본서버 신규/복귀 고객일 경우
		} else {
			this.getDataStateBannerAndSetting();
		}
	}

	getDataStateBannerAndSetting(){
		// 결과 값으로는 lineage2, lineage2Awakening, null 이 있다. -> 로그인 전에는 여기까지 안오므로 null 이 사용될 일은 없다
		let serverType = this.store.getData('config').charServerType;
		
		// 결과 값으로는 ROOKIE, DORMANT, ACTIVE => 신규, 휴면, 활성 이 있다.
		this.store.getData('StateBanner', {}, (result) => {
			if (result.data.state === 'ACTIVE' && serverType === 'lineage2') {
				this.$banner = $(`${this.el} .state-banner-1`);
			} else if ( result.data.state === 'ROOKIE' && (serverType === 'lineage2' || serverType === null) ) {
				this.$banner = $(`${this.el} .state-banner-2`);
			} else if (result.data.state === 'DORMANT' && serverType === 'lineage2') {
				this.$banner = $(`${this.el} .state-banner-2`);
			}

			this.$banner && this.setBanner();
		});
	}

	setBanner(){
		this.$banner.show().css('display', 'flex');
		this.addEvents()
	}

	addEvents() {
		$('.btn-close', this.$banner).on('click', () => {
			this.$banner.hide();
		});
	}

} // end of class
export default StateBanner;
